module.exports = __webpack_public_path__ + "static/img/platformone.166d43eb.png";